// extracted by mini-css-extract-plugin
var _1 = "Checkmark__checkmark-large--X9faf";
var _2 = "Checkmark__checkmark-medium--BV00q";
var _3 = "Checkmark__checkmark-small--hoToY";
export { _1 as "checkmark-large", _2 as "checkmark-medium", _3 as "checkmark-small" }
